module.exports = __webpack_public_path__ + "static/media/document-report.f3e368e4.svg";